import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-animated-loader',
  imports: [CommonModule],
  templateUrl: './animated-loader.html',
  styleUrl: './animated-loader.scss'
})
export class AnimatedLoader {

  hidden = input<boolean>();

  /** Path SVG — ombra nera dietro il fulmine */
  readonly pathOmbra =
    'M128.261 262.998L158.477 137.074L254.689 137.313L255.897 179.042' +
    'L237.533 239.888L226.945 315.201L183.907 368.351L142.318 361.753' +
    'L142.379 337.073L128.261 262.998Z';

  /** Path SVG — sfondo giallo */
  readonly pathSfondo =
    'M138.262 253.238L168.478 127.314L264.69 127.553L265.898 169.282' +
    'L247.534 230.128L236.946 305.441L193.908 358.591L152.319 351.993' +
    'L152.38 327.313L138.262 253.238Z';

  /** Path SVG — fulmine viola */
  readonly pathFulmine =
    'M239.98 137.62L194.059 137.937L169 221.353L186.517 224.988' +
    'L182.163 240.603L171.735 273.304L187.379 276.01L186.469 288.685' +
    'L175.45 347.62L232.131 246.945L224.413 246.396L214.444 245.686' +
    'L240 191.368L228.423 190.545L215.881 189.653L239.98 137.62Z';
}
